import { useMutation } from '@tanstack/react-query';
import { extractUserDetailsFromFile } from '../services/extractUserDetails';

/** POST /admin/extract-user-details */
export const useExtractUserDetailsMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    ...restOptions,
    meta: { handleErrorLocally: true, ...restOptions.meta },
    mutationFn: async (file) => {
      const result = await extractUserDetailsFromFile(file);
      if (!result.success) {
        throw new Error(result.message || 'Failed to extract user details');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
  });
};
